import { CartModel } from "@insite/client-framework/Types/ApiModels";

    // --- ADINA Time Functions
    export function getADITime() {
        let localTime = new Date();
        let utcTime = localTime.getUTCHours();
        let estTime = new Date();
        estTime.setHours(utcTime - 5);
        return estTime;
    };

    export function negitiveOffsetADITime(offset: number) {
        let d = getADITime(),
            h = d.getHours(),
            nh = h - offset,
            nd = d.setHours(nh);
        return new Date(nd);
    };

    export function isHourBefore (DateTime: Date, IntHour: number) {
        return DateTime.getHours() < IntHour;
    };

    export function isCodCustomer(cart: CartModel) {
        return cart.properties["custCOD"] == "500" ||
        cart.properties["custCOD"] == "881" ||
        cart.properties["custCOD"] == "888" ||
        cart.properties["custCOD"] == "991" ||
        cart.properties["custCOD"] == "999"
    }

    export function isFreeShipPromoApplied(cart: CartModel) {
        return cart.properties["freeShipPromocode"] && cart.properties["freeShipPromocode"] != "";
    }

    // Below function is from P21 change --- P21 Change
    export function isProductPromoApplied(cart: CartModel) {
        return cart.properties["customerPromocode"] && cart.properties["customerPromocode"] != "";
    }

     // Below function is from P21 change --- P21 Change
    export function updateCartCalculationWithNewCart (newCart: any, source: string)
    {
        let orderGrandTotal = 0;
        let shipping = 0;
        let totalOrderTax = 0;
        let totalAllDiscounts = 0;
        let shippingTax = 0;
        let orderFinalGrandTotal = 0;
        
        orderGrandTotal = newCart.orderSubTotal;
        totalOrderTax = parseFloat((newCart.properties["orderMaterialTax"]));
        totalAllDiscounts = parseFloat(newCart.properties["customDiscountAmount"]);

        if (totalOrderTax == undefined || isNaN(totalOrderTax) || (newCart?.properties['sC_TBD'] == 'Y')) {
            totalOrderTax = 0;
        }
        if (isNaN(totalAllDiscounts)) {
            totalAllDiscounts = 0;
        }

        
        if ( !isFreeShipPromoApplied(newCart) && isProductPromoApplied(newCart)) {  

            if (newCart.properties["customDiscountGrandTotal"] != undefined)                          
                orderGrandTotal = parseFloat(newCart.properties["customDiscountGrandTotal"]);           
            if (newCart.properties["orderMaterialTaxAfterPromo"] != undefined && source == "Promo")
                totalOrderTax = parseFloat(newCart.properties["orderMaterialTaxAfterPromo"]);
            else if (newCart.properties["orderMaterialTaxAfterPromo"] != undefined && source == 'Pickup' && newCart.properties["BranchPickupMaterialTax"] != undefined)
                totalOrderTax = parseFloat(newCart.properties["BranchPickupMaterialTax"]);
            else if (newCart.properties["orderMaterialTaxAfterPromo"] != undefined && source == 'Ship' && newCart.properties["orderMaterialTax"] != undefined)
                totalOrderTax = parseFloat(newCart.properties["orderMaterialTax"]);
            if(newCart.properties["freightTax"] != undefined)
            shippingTax = parseFloat(newCart.properties["freightTax"]);
            if (!newCart.showTaxAndShipping)
                shipping = 0;
            else {
                shipping = parseFloat(newCart.properties["freightCost"]);
            }
            if (
                newCart.properties["shippingSelection"] == "pickup" ||
                newCart.properties["shippingSelection"] == "pickup_mob"
            ) {
                shipping = 0;
                shippingTax = 0;
            }
           
        } else if (isFreeShipPromoApplied(newCart) && isProductPromoApplied(newCart)) {
           
            if (newCart.properties["customDiscountGrandTotal"] != undefined)           
                orderGrandTotal = parseFloat(newCart.properties["customDiscountGrandTotal"]);                
            if (newCart.properties["orderMaterialTaxAfterPromo"] != undefined && source == "Promo")
                totalOrderTax = parseFloat(newCart.properties["orderMaterialTaxAfterPromo"]);
            else if (newCart.properties["orderMaterialTaxAfterPromo"] != undefined && source == 'Pickup' && newCart.properties["BranchPickupMaterialTax"] != undefined)
                totalOrderTax = parseFloat(newCart.properties["BranchPickupMaterialTax"]);
            else if (newCart.properties["orderMaterialTaxAfterPromo"] != undefined && source == 'Ship' && newCart.properties["orderMaterialTax"] != undefined)
                totalOrderTax = parseFloat(newCart.properties["orderMaterialTax"]);
            shipping = 0;
            shippingTax = 0;
        }
        else if (isFreeShipPromoApplied(newCart) && !isProductPromoApplied(newCart)) {
            shipping = 0;
            shippingTax = 0;
        }
        else if (parseFloat(newCart.properties["BranchPickupMaterialTax"]) > 0) {
            shippingTax = 0;
            shipping = 0;
            totalOrderTax = parseFloat(newCart.properties["BranchPickupMaterialTax"])
          } else {   
           shippingTax = parseFloat(newCart.properties["freightTax"]);
            if (!newCart.showTaxAndShipping) 
                shipping = 0;
            else shipping = parseFloat(newCart.properties["freightCost"]);
            if (
                newCart.properties["shippingSelection"] == "pickup" ||
                newCart.properties["shippingSelection"] == "pickup_mob"
            ) {
                shipping = 0;
            }
        }
        if (
            newCart.properties["shippingSelection"] == "pickup" ||
            newCart.properties["shippingSelection"] == "pickup_mob"
        ) {
            shipping = 0;
        }

        if (newCart.freeshipReturnCode != "10") {
            orderFinalGrandTotal = orderGrandTotal + shipping + totalOrderTax + shippingTax;
            newCart.properties["finalGrandTotal"] = `${orderFinalGrandTotal.toFixed(2)}` || "";
            newCart.properties["TotalTax"] = `${(totalOrderTax + shippingTax).toFixed(2)}` || "";
            newCart.properties["freightCharge"] = `${shipping.toFixed(2)}` || "";
            newCart.shippingAndHandling = shipping.toFixed(2);
            newCart.totalTax = (totalOrderTax + shippingTax).toFixed(2);           
            newCart.finalGrandTotal = `${orderFinalGrandTotal.toFixed(2)}` || "";
            newCart.finalGrandTotalDisplay = `${newCart.currencySymbol}${orderFinalGrandTotal.toFixed(2)}`;
          
        }

        // to handle Nan scenarios
        if (Number.isNaN(newCart.totalTax))
            newCart.totalTax = 0;
        if(Number.isNaN(newCart.finalGrandTotal))
        {
            newCart.finalGrandTotal = 0;
            newCart.finalGrandTotalDisplay = "$0";
        }

        // if (newCart.finalGrandTotal)
        //     {
        //         newCart.finalGrandTotal = (Number(newCart["finalGrandTotal"]) +
        //         (newCart.totalEcoFeeDisplay ? Number(newCart.totalEcoFeeDisplay.split("$")[1]) : 0) +
        //         (newCart.totalSpecialHandlingFeeDisplay
        //             ? Number(newCart.totalSpecialHandlingFeeDisplay.split("$")[1])
        //             : 0)
        //     ).toFixed(2);
        //     newCart.properties["finalGrandTotal"] = newCart.finalGrandTotal;
        //     newCart.finalGrandTotalDisplay = `${newCart.currencySymbol}${newCart.finalGrandTotal}`;
        //     }
      
    
        return newCart;
    }

    // Below function is from P21 change --- P21 Change
    const formatAsCurrency = (num: number) => {
        return num.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
        });
    };
